var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmProducts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.811,
    height: 15.524,
    viewBox: "0 0 17.811 15.524",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.935,5.94H18.518a.97.97,0,0,0,0-1.94H4.935a.97.97,0,1,0,0,1.94ZM19.644,7.687a.968.968,0,0,0-.951-.776H4.761a.968.968,0,0,0-.951.776l-.97,4.851A.975.975,0,0,0,3.79,13.7h.175v4.851a.973.973,0,0,0,.97.97H12.7a.973.973,0,0,0,.97-.97V13.7h3.881v4.851a.97.97,0,0,0,1.94,0V13.7h.175a.975.975,0,0,0,.951-1.164Zm-7.917,9.9H5.905V13.7h5.821Z",
    transform: "translate(-2.821 -4)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admProducts.18f1e22a.svg";
export { ForwardRef as ReactComponent };